export default __webpack_public_path__ + "static/media/programming.7354b2d0.svg";